import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import { FaInstagram, FaFacebookF } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="top-bar">
        <img
          src="\baner_novi_beli.jpg"
          alt="Serbian Trophy Logo"
          className="logo"
        />

        {/* Hamburger Button for Mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
          <span className={menuOpen ? "bar open" : "bar"}></span>
        </div>
      </div>

      {/* Navigation */}
      <nav className={menuOpen ? "nav open" : "nav"}>
        <ul className="nav-links">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              ABOUT THE RACE
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to="/rules"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              PIVACY POLICY
            </NavLink>
          </li> */}
          <li>
            <NavLink
              to="/results"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              RESULTS
            </NavLink>
          </li>
        </ul>
        <div className="nav-right">
          <span className="event-date">NOV 5-8, 2026</span>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/serbiantrophy/?igshid=MzRlODBiNWFlZA%3D%3D"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/SerbianTrophy?mibextid=ZbWKwL"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
